import { NetworkError } from "@bonliva-crm/common/errors";
import { msalInstance, getToken, loginRequest } from "../msalConfig";

export const getSignInAsUserEmail = () =>
  typeof sessionStorage !== "undefined" ? sessionStorage.getItem("singInAsUser") : null;

export async function adfetch(
  url: string,
  options: Partial<RequestInit> = {}
): Promise<Response> {
  const { headers = {}, ...restOptions } = options;

  const extraHeaders: { "X-POSE-USER"?: string; Authorization?: string } = {};

  const signInAsUser = getSignInAsUserEmail();

  if (signInAsUser) {
    extraHeaders["X-POSE-USER"] = signInAsUser;
  }

  const account = msalInstance.getActiveAccount();

  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called."
    );
  }

  const token = await getToken();

  extraHeaders["Authorization"] = `Bearer ${token}`;

  const reqOptions: RequestInit = {
    ...restOptions,
    headers: {
      ...headers,
      ...extraHeaders
    },
    credentials: "include" as RequestCredentials
  };

  const response = await fetch(url, reqOptions);

  if (response.ok) {
    return response;
  }

  if (response.status === 401) {
    // Try refreshing the token and retrying the request
    const newToken = await getToken();
    if (newToken) {
      const retryResponse = await fetch(url, {
        ...restOptions,
        headers: {
          ...headers,
          ...extraHeaders,
          Authorization: `Bearer ${newToken}`
        },
        credentials: "include" as RequestCredentials
      });
      if (retryResponse.ok) {
        return retryResponse;
      }
    }

    // Token refresh failed — redirect to login
    msalInstance.loginRedirect({
      scopes: loginRequest.scopes
    }).catch((error) => {
      if (error?.errorCode !== "interaction_in_progress") {
        console.error("Login redirect error:", error);
      }
    });

    // Page is redirecting — return a never-resolving promise to suppress errors
    return new Promise<Response>(() => {});
  }

  throw new NetworkError(response.status, response.statusText);
}

export const fileDownloadHeaders = {
  "Content-Type": "application/json"
};
